import { render, staticRenderFns } from "./IMailing.vue?vue&type=template&id=1ce9b8e8&"
import script from "./IMailing.vue?vue&type=script&lang=ts&"
export * from "./IMailing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports